import React from "react"
import styled from "styled-components"
import { RelatedBlogFetch } from "./RelatedBlogFetch"
import Carousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css"

const responsive = {
	desktop: {
		breakpoint: { max: 3000, min: 1024 },
		items: 3,
		slidesToSlide: 3, // optional, default to 1.
	},
	tablet: {
		breakpoint: { max: 1024, min: 464 },
		items: 3,
		slidesToSlide: 2, // optional, default to 1.
	},
	mobile: {
		breakpoint: { max: 464, min: 0 },
		items: 2,
		partialVisibilityGutter: 15,
		slidesToSlide: 1, // optional, default to 1.
	},
}

const Container = styled.div`
	margin: 0 auto;
	width: 100%;
	background: #f7f7f7;
	padding-bottom: 60px;
`

const Heading = styled.h4`
	color: #050505;
	font-family: Mallory-Book;
	font-size: 24px;
	font-weight: 300;
	letter-spacing: 0;
	line-height: 22px;
	text-align: center;
	margin-bottom: 32px;
	text-transform: none;
`

const FlexBlogs = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	@media (max-width: 767px) {
		display: none;
	}
`

const SecondContainer = styled.div`
	max-width: 1240px;
	margin: auto;
`

export const ArticleFooter = ({ data }) => {
	const firstRelatedSlug = data.first_related_blog.uid
	const secondRelatedSlug = data.second_related_blog.uid
	const thirdRelatedSlug = data.third_related_blog.uid
	const fourthRelatedSlug = data.fourth_related_blog.uid

	const relatedArray = [
		firstRelatedSlug,
		secondRelatedSlug,
		thirdRelatedSlug,
		fourthRelatedSlug,
	]

	if (firstRelatedSlug) {
		return (
			<>
				<Container>
					<SecondContainer>
						<Heading>More from Milligram Notes</Heading>
						<FlexBlogs>
							{relatedArray.map((related, i) => {
								return (
									<>
										<RelatedBlogFetch data={related} value={i} />
									</>
								)
							})}
						</FlexBlogs>
						<Carousel
							swipeable={true}
							draggable={true}
							showDots={false}
							responsive={responsive}
							centerMode={false}
							partialVisible={true}
							ssr={true} // means to render carousel on server-side.
							infinite={false}
							keyBoardControl={true}
							customTransition="all .5"
							transitionDuration={500}
							containerClass="carousel-container"
							removeArrowOnDeviceType={["tablet", "mobile"]}
							dotListClass="custom-dot-list-style"
							itemClass="carousel-item-blogs"
						>
							{relatedArray.map((related, i) => {
								return (
									<>
										<RelatedBlogFetch data={related} value={i} />
									</>
								)
							})}
						</Carousel>
					</SecondContainer>
				</Container>
			</>
		)
	}
	return <></>
}
